<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.33301 4.66659C3.1562 4.66659 2.98663 4.73682 2.8616 4.86185C2.73658 4.98687 2.66634 5.15644 2.66634 5.33325V12.6666C2.66634 12.8434 2.73658 13.013 2.8616 13.138C2.98663 13.263 3.1562 13.3333 3.33301 13.3333H10.6663C10.8432 13.3333 11.0127 13.263 11.1377 13.138C11.2628 13.013 11.333 12.8434 11.333 12.6666V8.66659C11.333 8.2984 11.6315 7.99992 11.9997 7.99992C12.3679 7.99992 12.6663 8.2984 12.6663 8.66659V12.6666C12.6663 13.197 12.4556 13.7057 12.0806 14.0808C11.7055 14.4559 11.1968 14.6666 10.6663 14.6666H3.33301C2.80257 14.6666 2.29387 14.4559 1.91879 14.0808C1.54372 13.7057 1.33301 13.197 1.33301 12.6666V5.33325C1.33301 4.80282 1.54372 4.29411 1.91879 3.91904C2.29387 3.54397 2.80257 3.33325 3.33301 3.33325H7.33301C7.7012 3.33325 7.99967 3.63173 7.99967 3.99992C7.99967 4.36811 7.7012 4.66659 7.33301 4.66659H3.33301Z"
      fill="#007893"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.33301 1.99992C9.33301 1.63173 9.63148 1.33325 9.99967 1.33325H13.9997C14.3679 1.33325 14.6663 1.63173 14.6663 1.99992V5.99992C14.6663 6.36811 14.3679 6.66658 13.9997 6.66658C13.6315 6.66658 13.333 6.36811 13.333 5.99992V2.66659H9.99967C9.63148 2.66659 9.33301 2.36811 9.33301 1.99992Z"
      fill="#007893"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4714 1.52851C14.7318 1.78886 14.7318 2.21097 14.4714 2.47132L7.13807 9.80466C6.87772 10.065 6.45561 10.065 6.19526 9.80466C5.93491 9.54431 5.93491 9.1222 6.19526 8.86185L13.5286 1.52851C13.7889 1.26816 14.2111 1.26816 14.4714 1.52851Z"
      fill="#007893"
    />
  </svg>
</template>
